import { createSlice } from "@reduxjs/toolkit";
import { create_or_update_opentab_thunk, get_opentabs_thunk } from "./opentabThunk";

const initialState = {
    loading: false,
    openTabs: [],
    error: null,
};

const loadOpenTabsFromLocalStorage = () => {
    const openTabs = localStorage.getItem('openTabs');
    // Check if openTabs is null or an empty string
    if (!openTabs || openTabs === 'undefined') {
        return [];
    }
    try {
        return JSON.parse(openTabs);
    } catch (error) {
        console.error('Error parsing JSON:', error);
        return [];
    }
};

const createOpentabCases = (builder) => {
    builder
        .addCase(create_or_update_opentab_thunk.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(create_or_update_opentab_thunk.fulfilled, (state, action) => {
            state.loading = false;
        })
        .addCase(create_or_update_opentab_thunk.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || "Login Cases Error";
        });
};

const getOpentabCases = (builder) => {
    builder
        .addCase(get_opentabs_thunk.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(get_opentabs_thunk.fulfilled, (state, action) => {
            state.openTabs = action.payload.data.response;
            state.loading = false;
        })
        .addCase(get_opentabs_thunk.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || "Login Cases Error";
        });
};

const opentabSlice = createSlice({
    name: "opentab",
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
        getOpenTabsFromLocalStorage: (state, action) => {
            state.openTabs = loadOpenTabsFromLocalStorage();
        },
        setOpenTabs: (state, action) => {
            state.openTabs = action.payload;
            localStorage.setItem('openTabs', JSON.stringify(action.payload));
        },
        clearOpenTabs: (state) => {
            state.openTabs = [];
        },

    },
    extraReducers: (builder) => {
        createOpentabCases(builder);
        getOpentabCases(builder);
        // logoutCases(builder);
    },
});

export const { clearError, getOpenTabsFromLocalStorage, setOpenTabs, clearOpenTabs } = opentabSlice.actions;

export default opentabSlice.reducer;
